import React from 'react'
import { components } from 'react-select'
import { useSelector } from 'react-redux'

import { selectedPartnershipRightsHolderSelfAccountSelector } from '../../../../modules/selectors/app'

import useStyles from './styles'

// this component is used for 2 cases first for simple static representation of Single partnership
// second is to be a part of Select component which is used as a custom ValueContainer
const PartnershipSelectValueContainer = props => {
  const classes = useStyles()

  const values = (props.selectProps && props.selectProps.value) || {}

  const additionalInfo = props.additionalPartnershipInfo || props?.selectProps?.additionalPartnershipInfo

  const { img, name, partner_name: partnerName, rights_holder_name: rightsHolderName } = values

  const selectedPartnershipRightsHolderSelfAccount = useSelector(selectedPartnershipRightsHolderSelfAccountSelector)

  // right holder account icon and name may be updated,
  // so we get them from selectedPartnershipRightsHolderSelfAccount, to represent the latest changes
  const rightHolderSelfAccountIcon = selectedPartnershipRightsHolderSelfAccount?.icon
  const rightHolderSelfAccountName = selectedPartnershipRightsHolderSelfAccount?.label

  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <img
          className={classes.icon}
          src={rightHolderSelfAccountIcon || img}
          alt="icon"
          onLoad={i => (i.target.style.display = 'block')}
          onError={i => (i.target.style.display = 'none')}
        />
      </div>
      <div>
        <div className={classes.nameContainer}>
          <div className={classes.name}>
            {rightHolderSelfAccountName || rightsHolderName} - {name}
          </div>
        </div>
        <div className={classes.nameBottomText}>
          {partnerName} {additionalInfo && ` | ${additionalInfo}`}
          {!props.previewOnly && <components.ValueContainer className={classes.value} {...props} />}
        </div>
      </div>
    </div>
  )
}

export default PartnershipSelectValueContainer
